"use client";

import { FeatureFlagComponentResolverClient } from "@/lib/feature-flags/FeatureFlagResolverClient";
import MonarchResolver from "@/monarch/MonarchResolver";
import type { SuperlativesModuleTestResult } from "@/monarch/rules/superlativesModule/types";
import BaseProductCollections from "./BaseProductCollections";
import type { ProductCollectionsProps } from "./types";

export default function ProductCollections({
  location,
  className,
}: ProductCollectionsProps) {
  return (
    <FeatureFlagComponentResolverClient
      flagKey="NEXT_PUBLIC_FEATURE_SUPERLATIVE_PRODUCT_CARDS"
      variants={{
        legacy: null,
        test: (
          <MonarchResolver<SuperlativesModuleTestResult>
            experimentKey="useSuperlativesModule"
            variants={{
              control: null,
              test: (
                <BaseProductCollections
                  location={location}
                  className={className}
                />
              ),
            }}
            fallbackVariant="control"
            Loader={null}
          />
        ),
      }}
      fallback="legacy"
    />
  );
}
